import { MaskLineInView } from "./Reveal";
import ServiceCard from "./ServiceCard";
import { studiosServices, collectiblesServices, SOCIALS } from "../data/services";

function BrandBlock({ id, kicker, titleLines, blurb, services, social, align = "left" }) {
  return (
    <section
      id={id}
      className="py-24 sm:py-32 border-t border-[#27272a] scroll-mt-20"
      data-testid={`section-${id}`}
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-14">
          <div className="lg:col-span-8">
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-gold">
              {kicker}
            </span>
            <h2 className="font-display text-4xl sm:text-6xl lg:text-7xl font-semibold uppercase tracking-tighter leading-[0.9] mt-5">
              {titleLines.map((t, i) => (
                <MaskLineInView key={i} delay={i * 0.08} className={t.gold ? "text-gold" : ""}>
                  {t.text}
                </MaskLineInView>
              ))}
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-zinc-400 leading-relaxed">{blurb}</p>
            <span className="inline-block mt-4 font-mono text-xs text-zinc-500 tracking-[0.15em]">
              {social}
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {services.map((s, i) => (
            <ServiceCard key={s.slug} service={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

export function StudiosSection() {
  return (
    <BrandBlock
      id="studios"
      kicker="[ SEC Studios — Creator Hub ]"
      titleLines={[
        { text: "Broadcast" },
        { text: "Grade Studio", gold: true },
      ]}
      blurb="Studio hire, streamer tech, custom branding and a turnkey incubator. 100% unbranded space, built entirely around your brand."
      services={studiosServices}
      social={SOCIALS.studios}
    />
  );
}

export function CollectiblesSection() {
  return (
    <BrandBlock
      id="collectibles"
      kicker="[ Premier Hobby & Card Services ]"
      titleLines={[
        { text: "Prep. Grade." },
        { text: "Consign.", gold: true },
      ]}
      blurb="Professional cleaning, group grading to PSA / BGS / CGC, and high-value consignment with industry-low commissions and fast payouts."
      services={collectiblesServices}
      social={SOCIALS.collectibles}
    />
  );
}
